var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0984 25.6799C16.6384 26.1399 16.0684 26.3699 15.3884 26.3699C14.7084 26.3699 14.1384 26.1399 13.6784 25.6799L3.11844 15.1199C2.89844 14.8999 2.72344 14.6399 2.59344 14.3399C2.46344 14.0399 2.39844 13.7199 2.39844 13.3799V4.7999C2.39844 4.1399 2.63344 3.5749 3.10344 3.1049C3.57344 2.6349 4.13844 2.3999 4.79844 2.3999H13.3784C13.7184 2.3999 14.0384 2.4649 14.3384 2.5949C14.6384 2.7249 14.8984 2.8999 15.1184 3.1199L25.6784 13.7099C26.1384 14.1699 26.3684 14.7349 26.3684 15.4049C26.3684 16.0749 26.1384 16.6399 25.6784 17.0999L17.0984 25.6799ZM7.79844 9.5999C8.29844 9.5999 8.72344 9.4249 9.07344 9.0749C9.42344 8.7249 9.59844 8.2999 9.59844 7.7999C9.59844 7.2999 9.42344 6.8749 9.07344 6.5249C8.72344 6.1749 8.29844 5.9999 7.79844 5.9999C7.29844 5.9999 6.87344 6.1749 6.52344 6.5249C6.17344 6.8749 5.99844 7.2999 5.99844 7.7999C5.99844 8.2999 6.17344 8.7249 6.52344 9.0749C6.87344 9.4249 7.29844 9.5999 7.79844 9.5999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountIcon);
export default __webpack_public_path__ + "static/media/DiscountIcon.b2a4caf6908e8d770ba33f8c3dde889a.svg";
export { ForwardRef as ReactComponent };